
import { toast } from "react-hot-toast";
import { authService } from "./auth.service";

class AwsS3 {
   s3 = null;
   fileUpload
   buffer
   fileURL

  constructor(fileUpload = null, buffer = false, fileURL = "") {
    this.fileUpload = fileUpload;
    this.buffer = buffer;
    this.fileURL = fileURL;
  }

 

  /**
   * Generates a pre-signed S3 URL for file upload and uploads the file.
   */
   async uploadFile() {
      try {
        const response = await authService.uploadS3File(this.fileUpload);
      console.log("Uploaded to S3")
      return response?.data
    } catch (error) {
      console.error("Error uploading file to S3:", error);
      toast.error("Failed to upload file.");
      throw error;
    }
  }

  /**
   * Deletes a file from S3.
   */
   async deleteFile() {
    try {

      await authService.deleteFile({file_url:this.fileURL});
      console.log("File deleted successfully:");
    } catch (error) {
      console.error("Error deleting file from S3:", error);
      throw error;
    }
  }

  /**
   * Duplicates an existing file in S3 and returns the new file URL.
   */
   async duplicateFile(){
    try {
      if (!this.fileURL) throw new Error("No file URL provided for duplication.");

     const response= await authService.duplicateFile({file_url:this.fileURL});

      console.log("File duplicated successfully:");
      return response.data;
    } catch (error) {
      console.error("Error duplicating file:", error);
      toast.error("Failed to duplicate file.");
      throw error;
    }
  }

  /**
   * Extracts the file extension from the fileUpload object.
   */
   getFileExtension() {
    return this.fileUpload?.name?.split(".").pop() || "unknown";
  }

  /**
   * Determines the MIME type of the file for the upload.
   */
   getMimeType() {
    return this.fileUpload?.type || "application/octet-stream";
  }

  getS3URL = async () => {
    try {
      const response = await authService.getS3URL(this.fileUpload);
      console.log("response?.data-->",response?.data);
      
      // console.log("uploadUrl", uploadUrl.split("?")[0]);
      return response?.data;
    } catch (error) {
      console.log(error);
      return "";
    }
  };

}

export default AwsS3;
